/*
 * @Descripttion:
 * @Author: lks
 * @Date: 2021-09-28 11:53:45
 * @LastEditors: lks
 * @LastEditTime: 2021-11-05 09:08:50
 */
import http from '@/plugin/axios';

export default {
  /**
   * 会员等级列表
   */
  getMemberList: (data: any): Promise<any> => {
    return http.post('wxApplet/member/getMemberList', data);
  },
  /**
   * 创建充值订单
   */
  saveRechargeOrder: (data: any): Promise<any> => {
    return http.post('recharge/saveRechargeOrder', data);
  },
  /**
   * 支付二维码
   */
  wxTradePagePay: (data: any): Promise<any> => {
    return http.post('active/pay/wxTradePagePay', data);
  },
  /**
   * 检查订单状态
   */
  getOrderStatus: (data: any): Promise<any> => {
    return http.post('active/pay/getOrderStatus', data);
  },
  /**
   * 用户充值订单
   */
  getUserRechargeList: (data: any): Promise<any> => {
    return http.post('recharge/getUserRechargeList', data);
  },
  /**
   * 申请发票
   */
  getInvoiceSaveOrUpdate: (data: any): Promise<any> => {
    return http.post('recharge/getInvoiceSaveOrUpdate', data);
  },
  /**
   * 发票详情
   */
  getInvoiceInfo: (data: any): Promise<any> => {
    return http.post('recharge/getInvoiceInfo', data);
  },
  /**
   * 撤销申请发票
   */
  getRevokeInvoice: (data: any): Promise<any> => {
    return http.post('recharge/getRevokeInvoice', data);
  },
  /**
   * 删除充值订单
   */
  getRechargeDel: (data: any): Promise<any> => {
    return http.post('recharge/getRechargeDel', data);
  },
  /**
   * 领取优惠券
   */
  saveOrUpdateUserCoupon: (data: any): Promise<any> => {
    return http.post('/activity/coupon/saveOrUpdateUserCoupon', data);
  },
  /**
   * 用户优惠券
   */
  getUserCouponList: (data: any): Promise<any> => {
    return http.post('/activity/coupon/getUserCouponList', data);
  },
  /**
   * 活动优惠券
   */
  getCouponList: (data: any): Promise<any> => {
    return http.post('/activity/coupon/getCouponList', data);
  },
  /**
   * 是否领取过优惠券
   */
  getCouponReceive: (data: any): Promise<any> => {
    return http.post('/activity/coupon/getCouponReceive', data);
  },
  /**
   * 对公转账凭证
   */
  saveOrderAccount: (data: any): Promise<any> => {
    return http.post('/recharge/saveOrderAccount', data);
  },
  /**
   * 生成二维码
   */
  wxTradePay: (data: any): Promise<any> => {
    return http.post('/active/pay/wxTradePay', data);
  },
  /**
   * 查询支付状态
   */
  getOrderState: (data: any): Promise<any> => {
    return http.post('/active/pay/getOrderState', data);
  },
  /**
   * 支付宝
   */
  aliTradePay: (data: any): Promise<any> => {
    return http.post('/active/pay/aliTradePay', data);
  },
  /**
   * 支付宝校验是否成功
   */
  alipayNotify: (data: any): Promise<any> => {
    return http.get('/active/pay/alipay/notify', { params: data });
  },
};
